import cloneDeep from 'lodash-es/cloneDeep';
import createRavenMiddleware from 'raven-for-redux';

export default (() => {
  if (window.Raven === undefined) {
    return () => next => action => next(action);
  }

  return createRavenMiddleware(window.Raven, {
    stateTransformer: state => {
      const clonedState = cloneDeep(state);

      if (clonedState.contentReducer && clonedState.contentReducer.history) {
        delete clonedState.contentReducer.history.past; // too big
        delete clonedState.contentReducer.history.future; // too big
      }
      delete clonedState.lastActionReducer; // lastAction is sent by the middleware

      return clonedState;
    },
  });
})();
